import { render } from "./Products.vue?vue&type=template&id=2660c1c0"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
script.render = render

export default script